/** ダブルタップ判定の時間閾値（ms） */
export const DOUBLE_TAP_THRESHOLD_MS = 500

/**
 * AI カラー編集キャンバスの最小ズーム倍率。
 * 初期表示 (scale 1 = コンテナ幅に合わせた表示) より縮小できるようにして、
 * 縦長画像を 1 画面に収められるようにする。maxScale 4 と対称の値。
 */
export const AI_COLOR_MIN_ZOOM_SCALE = 0.25

/**
 * プレビュー表示中の最小ズーム倍率（= 縮小しない）。
 *
 * プレビューは「施主に見せる完成形」なので、初期表示より小さくして余白を作る操作を提供しない
 * （issue #2417）。拡大して細部を見てから `元のサイズに戻す` で戻る動線だけを残す。
 */
export const AI_COLOR_PREVIEW_MIN_ZOOM_SCALE = 1

/**
 * AI カラー編集キャンバスの最大ズーム倍率。`ZoomableImage` の既定と同じ値だが、
 * 拡大ボタンの活性判定（上限に達したら押せない）に同じ値が必要なので定数に出す。
 */
export const AI_COLOR_MAX_ZOOM_SCALE = 4

/**
 * 拡大・縮小ボタン 1 回あたりの倍率の変化幅。
 * ホイールの刻み（0.1）より大きくして、1 回押したことが目に見えて分かるようにする。
 */
export const AI_COLOR_ZOOM_STEP = 0.5

/**
 * 生成結果に添えるディスクレーマー（issue #2417）。
 *
 * 生成は Gemini 依存で実物の色味を保証できないため、期待値を調整する文言を**画面内**と
 * **変換情報付きダウンロード画像**の両方に出す。文言が 2 箇所でずれると「画面では断っていたのに
 * 配布物では断っていない」状態になり得るので、ここを唯一の出どころにする。
 *
 * 文言は Biz 確認中の暫定。従来ダウンロード画像に焼いていた「実際の色味は環境・光源・塗料仕様により
 * 異なる場合があります」は色変更向けで、建材を置き換える素材変更の結果には意味がずれるため、
 * 質感と建材の仕様も含む言い方にした。確定後はこの 1 箇所の差し替えで画面・画像の双方に反映される。
 */
export const AI_COLOR_RESULT_DISCLAIMER =
  '※シミュレーション画像は完成イメージです。実際の色味や質感は、環境・光源・塗料や建材の仕様により異なる場合があります。'

/**
 * カスタムエリアの有効範囲設定（`SubArea.useDetectedAreaOnly`）の文言（issue #2413）。
 *
 * 「カスタムエリアを設定したのに色が変わらない」問い合わせの大半が、この設定が ON のまま
 * ベースエリア外を囲ったことによる。
 *
 * 設定への入口は 2 つあり、**共有しているのは補足文（`_DESCRIPTION`）だけ**:
 * - レイヤー一覧（`AreaColorSelector`）: ラベルは `_LABEL`（短い方）
 * - 設定ダイアログ（`CustomAreaSettingDialog`）: ラベルは従来の長文をハードコードで維持
 *
 * ラベルが入口ごとに違うのは意図的（Notion モックアップの指定）。狭い一覧では短く、
 * 設定画面では従来の表現を残して既存ユーザーの記憶と食い違わせない。
 */
export const CUSTOM_AREA_DETECTED_ONLY_LABEL = 'ベースエリア内のみ有効'

/**
 * 上記設定の常時表示する補足文。レイヤー一覧・設定ダイアログの両方で使うため、
 * ここに集約して 2 箇所の drift を防ぐ。
 *
 * 「何を制限するか」ではなく「ON にすると何が起きないか」を述べる（結果ベース）。
 * 仕組みの説明では、色が変わらない理由にユーザーが自力で到達できないため。
 */
export const CUSTOM_AREA_DETECTED_ONLY_DESCRIPTION =
  'ONの場合、ベースエリアとして認識されていない部分は色が変わりません。'

/** 上記設定のツールチップ。補足文より一歩踏み込んで「どうすればよいか」を示す。 */
export const CUSTOM_AREA_DETECTED_ONLY_TOOLTIP =
  'ベースエリア（外壁・屋根）として自動認識された範囲だけにカスタムエリアを適用します。認識されていない箇所（増築部分や付帯物など）を塗りたい場合はOFFにしてください。'
